import React from 'react'
import EmployeeListTable from './components/EmployeeListTable'
import AddItemBtn from 'Common/Custom/AddItemBtn';
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const EmployeeList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Employee List</HeadingOne>
                    <AddItemBtn url="add-employee" title="Add Employee" />
                </>
            }>
            <div className="col-12">
                <EmployeeListTable />
            </div>
        </PageBody>
    );
};

export default EmployeeList;
